// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media print {
  @page {
    padding: 10mm;
  }

  .page-number {
    display: none !important;
  }

  /* Дополнительные стили для печати */

  /* Другие настройки стилей для печатной версии */
}
`, "",{"version":3,"sources":["webpack://./src/styles/print.css"],"names":[],"mappings":"AAAA;EACE;IACE,aAAa;EACf;;EAEA;IACE,wBAAwB;EAC1B;;EAEA,oCAAoC;;EAEpC,gDAAgD;AAClD","sourcesContent":["@media print {\n  @page {\n    padding: 10mm;\n  }\n\n  .page-number {\n    display: none !important;\n  }\n\n  /* Дополнительные стили для печати */\n\n  /* Другие настройки стилей для печатной версии */\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
